import axios from 'axios'
import { getToken } from '@/util/auth' // get token from cookie
import {
  Loading
} from 'element-ui';

/**
 * 最新版
 */

const service = axios.create({
  baseURL: tmsSpringUrl,
  timeout: 600000
})
service.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";


let isHttp = false;
if (window.location.protocol == "https:") {
  isHttp = true;
}
let loadingInstance

// Add a request interceptor
service.interceptors.request.use(config => {

//   config.baseURL = tmsSpringUrl;
  config.withCredentials = true
  config.timeout = 600000

  loadingInstance = Loading.service({
    text: 'Loading.....',
    lock: true,
    fullscreen: true,
    background: "rgba(0, 0, 0, 0.8)",
    spinner: "el-icon-loading"
  });

  let t = getToken()
  config.headers['tmsSpringTokenSeller'] = !t || t == 'undefined' ? '' : t

  return config;
},
  error => {
    loadingInstance.close();
    if (error.response && error.response.status == 401) {
      // todo-login
      // var r = jsRoutes.controllers.oauth.OAuthController.corsLogin(window.location.href);
      // window.location.href = r;

      // if(window.location.href.indexOf('/login') == -1){
      //     window.location.href = '/login'
      // }
    }
    return Promise.reject(error)
  });
// Add a response interceptor
service.interceptors.response.use(function (response) {
  // Do something with response data
  loadingInstance.close();
  return response;
}, function (error) {
  // Do something with response error
  //没有登陆重新登陆
  loadingInstance.close();
  if (error.response && error.response.status == 401) {
    // todo-login
    // var r = jsRoutes.controllers.oauth.OAuthController.corsLogin(window.location.href);
    // window.location.href = r;


    if(window.location.href.indexOf('/login') == -1){
        window.location.href = '/login'
    }

  }
  return Promise.reject(error);
});




export default service



// WEBPACK FOOTER //
// ./src/util/request1.js